import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_file_sources/{?id}')
@doc.timestampable
abstract class AbstractStonecodeFileSourceModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		entityUrn: Urn;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare entityUrn: Urn;
}

interface AbstractStonecodeFileSourceModel extends Timestampable {}

export default AbstractStonecodeFileSourceModel;
